import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream-2 px-4 py-14" data-id="element-128" data-mp="1o46kamqgrqwm">
      <div className="mx-auto max-w-2xl rounded-3xl border-2 border-sage/40 bg-white p-6 text-center shadow-lg sm:p-9" data-id="element-129" data-mp="1o3do2fp4sjsq">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-sage/15" data-id="element-130" data-mp="22124nbc614rz">
          <ShieldCheckIcon className="h-9 w-9 text-sage" data-id="element-131" data-mp="19eqwnfm8c1l5" />
        </div>
        <h2 className="mt-4 font-display text-2xl font-black text-plum-deep sm:text-3xl" data-id="element-132" data-mp="19f0m923d46qb">
          🛡️ Garantía de 7 días
        </h2>
        <p className="mt-3 text-sm font-semibold text-mauve" data-id="element-133" data-mp="1j4aganhrnzh2">
          Si no te ayuda a decidir qué tejer más rápido, te devolvemos tu
          dinero.
        </p>
        <p className="mt-4 text-sm leading-relaxed text-plum/75" data-id="element-134" data-mp="1ecivktlaknyu">
          Queremos que compres con total tranquilidad. Por eso tienes 7 días
          completos para revisar cada tomo, probar el Árbol Inteligente de
          Decisiones y utilizar todos los recursos incluidos.
        </p>
        <p className="mt-4 text-sm leading-relaxed text-plum/75" data-id="element-135" data-mp="oz9l4vayd1ix">
          Si durante ese tiempo sientes que el sistema no cumplió lo prometido…
          solo escríbenos. Te devolveremos el <strong data-id="element-136" data-mp="yqmbtjl0llnd">100% de tu dinero</strong>.
          Sin explicaciones. Sin preguntas. Sin complicaciones.
        </p>
        <p className="mt-4 font-display text-base font-bold italic text-plum" data-id="element-137" data-mp="12q4v6ax6too3">
          El riesgo es completamente nuestro.
        </p>
      </div>
    </section>;
}